<template lang="">
    <div>
        <menu-hmi @seleccion="seleccion"></menu-hmi>
        <hmi-secadero v-if="elegido==0"></hmi-secadero>
        <hmi-principal :datos="this.datos.main" v-if="elegido==1"  @cambio_auto_man="cambio_auto_man" ></hmi-principal>
        <!-- <hmi-reguladores1 v-if="elegido==2"></hmi-reguladores1>
        <hmi-reguladores2 v-if="elegido==3"></hmi-reguladores2> -->
        <hmi-reguladores v-if="elegido==2"></hmi-reguladores>
    </div>
</template>
<script>
    import MenuHmi from "@/components/HMI/MenuHmi.vue";
    import HmiSecadero from "@/components/HMI/HmiSecadero.vue";
    import HmiPrincipal from "@/components/HMI/HmiPrincipal.vue";
    // import HmiReguladores1 from "@/components/HMI/HmiReguladores1.vue";
    // import HmiReguladores2 from "@/components/HMI/HmiReguladores2.vue";
    import HmiReguladores from "@/components/HMI/HmiReguladores.vue";
import { mapActions, mapState } from 'vuex';

export default {
    components:{
        MenuHmi,HmiSecadero,HmiPrincipal,
       
        HmiReguladores
    },//fin de los componentes

    computed: {
        ...mapState("nodered",['client'])
    },

    data() {
        return {
            //Seleccion: 0 -> inicio, 1->Principal, 2->Reguladores 1 y 3->Reguladores 2
            elegido:2,
            suscribed:{
                'main':false
            },

            datos:{
                main:{}
            }
            
        }
    },



    methods: {
        ...mapActions("nodered",['doSubscribe','doPublish']),
        cambio_auto_man(val){
            this.data['Selector_Auto-Man']=val;
            this.data.splice();
        },
        seleccion(s){
            console.log(typeof(s))
            this.elegido=s;
            switch (s) {
                case 1:
                    console.log("ha elegido 1111")
                    if(!this.suscribed.main) this.doSubscribe('MAIN')
                    this.suscribed.main=true;
                    let publication={
                        topic:'GET_MAIN',
                        qos:0,
                        payload:JSON.stringify({'valor':1}) ,
                    }
                    this.doPublish(publication)
                    break;
                case 2:
                    this.suscribed.main=false;
                    let publication2={
                        topic:'GET_REGULADORES1',
                        qos:0,
                        payload:JSON.stringify({'valor':1}) ,
                    }
                    this.doPublish(publication2)
                    let publication3={
                        topic:'GET_REGULADORES2',
                        qos:0,
                        payload:JSON.stringify({'valor':1}) ,
                    }
                    this.doPublish(publication3)
                    break;
            
                default:
                    console.log("ni idea.....")
                    break;
            }
        },//FIN SELECCION
        tratarMain(mensaje){
            // console.log(mensaje)
            if(mensaje.length>0){
                let a = JSON.parse(mensaje)
                this.datos.main=a;
                // console.log(a)
            }
         

        }
    },//FIN METODOS

    created() {
        this.client.on('message', (topic, message) => {
            if(topic=="MAIN"){
                this.tratarMain(message)
            }      
      }),
      this.seleccion(2);
    },
    
}
</script>
<style lang="">
    
</style>